
import Shipment_Return from "../../../public/assets/icons/Shipment_Return.svg";
import { some } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { empty, isEmpty, map, append, singleton, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import Following from "../../../public/assets/icons/Following.svg";
import User_Multiple_Group from "../../../public/assets/icons/User_Multiple_Group.svg";
import Followers from "../../../public/assets/icons/Followers.svg";
import { NotificationId__get_unwrap } from "../../Shared/Shared.js";
import { mutate } from "swr";
import swr from "swr";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { OverviewNotification_$reflection } from "../../Shared/Notification.js";
import { list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton as singleton_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Loading_Circle from "../../../public/assets/icons/Loading_Circle.svg";
import { DropdownButton } from "../../Components/Button.js";
import Bell_Notification from "../../../public/assets/icons/Bell_Notification.svg";
import Notification_Alarm_2 from "../../../public/assets/icons/Notification_Alarm_2.svg";

export function toDropdownButtonElement(t, notification) {
    let arg_3, arg_5, arg_7, arg_9, arg_11, arg_13, arg_15, arg_17, arg_19, arg_21, arg_23, arg_25, arg_27, arg_29, arg_31, arg_1;
    const matchValue = notification.NotificationType;
    switch (matchValue) {
        case "toolUserToStorageRequest": {
            const Icon_1 = some(Shipment_Return());
            return {
                DisplayName: (arg_3 = {
                    name: notification.EntityName,
                    sender: notification.Sender,
                }, t("notification.tool_user_to_storage_request", arg_3)),
                Icon: Icon_1,
                OnClick: (_arg_1) => {
                    RouterModule_nav(ofArray(["tools", notification.EntityId]), 1, 1);
                },
            };
        }
        case "toolStorageToUserAssignment": {
            const Icon_2 = some(Following());
            return {
                DisplayName: (arg_5 = {
                    name: notification.EntityName,
                }, t("notification.tool_storage_to_user", arg_5)),
                Icon: Icon_2,
                OnClick: (_arg_2) => {
                    RouterModule_nav(ofArray(["tools", notification.EntityId]), 1, 1);
                },
            };
        }
        case "toolUserToUserAssignment": {
            const Icon_3 = some(User_Multiple_Group());
            return {
                DisplayName: (arg_7 = {
                    name: notification.EntityName,
                    sender: notification.Sender,
                }, t("notification.tool_user_to_user", arg_7)),
                Icon: Icon_3,
                OnClick: (_arg_3) => {
                    RouterModule_nav(ofArray(["tools", notification.EntityId]), 1, 1);
                },
            };
        }
        case "toolWithQuantityBackToStorage": {
            const Icon_4 = some(Followers());
            return {
                DisplayName: (arg_9 = {
                    name: notification.EntityName,
                    sender: notification.Sender,
                }, t("notification.tool_with_quantity_back_to_storage", arg_9)),
                Icon: Icon_4,
                OnClick: (_arg_4) => {
                    RouterModule_nav(ofArray(["toolswithquantity", notification.EntityId]), 1, 1);
                },
            };
        }
        case "toolWithQuantityUserToStorageRequest": {
            const Icon_5 = some(Shipment_Return());
            return {
                DisplayName: (arg_11 = {
                    name: notification.EntityName,
                    sender: notification.Sender,
                }, t("notification.tool_with_quantity_user_to_storage_request", arg_11)),
                Icon: Icon_5,
                OnClick: (_arg_5) => {
                    RouterModule_nav(ofArray(["toolswithquantity", notification.EntityId]), 1, 1);
                },
            };
        }
        case "toolWithQuantityStorageToUserAssignment": {
            const Icon_6 = some(Following());
            return {
                DisplayName: (arg_13 = {
                    name: notification.EntityName,
                }, t("notification.tool_with_quantity_storage_to_user", arg_13)),
                Icon: Icon_6,
                OnClick: (_arg_6) => {
                    RouterModule_nav(ofArray(["toolswithquantity", notification.EntityId]), 1, 1);
                },
            };
        }
        case "toolWithQuantityUserToUserAssignment": {
            const Icon_7 = some(User_Multiple_Group());
            return {
                DisplayName: (arg_15 = {
                    name: notification.EntityName,
                    sender: notification.Sender,
                }, t("notification.tool_with_quantity_user_to_user", arg_15)),
                Icon: Icon_7,
                OnClick: (_arg_7) => {
                    RouterModule_nav(ofArray(["toolswithquantity", notification.EntityId]), 1, 1);
                },
            };
        }
        case "setBackToStorage": {
            const Icon_8 = some(Followers());
            return {
                DisplayName: (arg_17 = {
                    name: notification.EntityName,
                    sender: notification.Sender,
                }, t("notification.set_back_to_storage", arg_17)),
                Icon: Icon_8,
                OnClick: (_arg_8) => {
                    RouterModule_nav(ofArray(["sets", notification.EntityId]), 1, 1);
                },
            };
        }
        case "setUserToStorageRequest": {
            const Icon_9 = some(Shipment_Return());
            return {
                DisplayName: (arg_19 = {
                    name: notification.EntityName,
                    sender: notification.Sender,
                }, t("notification.set_user_to_storage_request", arg_19)),
                Icon: Icon_9,
                OnClick: (_arg_9) => {
                    RouterModule_nav(ofArray(["sets", notification.EntityId]), 1, 1);
                },
            };
        }
        case "setStorageToUserAssignment": {
            const Icon_10 = some(Following());
            return {
                DisplayName: (arg_21 = {
                    name: notification.EntityName,
                }, t("notification.set_storage_to_user", arg_21)),
                Icon: Icon_10,
                OnClick: (_arg_10) => {
                    RouterModule_nav(ofArray(["sets", notification.EntityId]), 1, 1);
                },
            };
        }
        case "setUserToUserAssignment": {
            const Icon_11 = some(User_Multiple_Group());
            return {
                DisplayName: (arg_23 = {
                    name: notification.EntityName,
                    sender: notification.Sender,
                }, t("notification.set_user_to_user", arg_23)),
                Icon: Icon_11,
                OnClick: (_arg_11) => {
                    RouterModule_nav(ofArray(["sets", notification.EntityId]), 1, 1);
                },
            };
        }
        case "consumableStorageToUserAssignment": {
            const Icon_12 = some(Following());
            return {
                DisplayName: (arg_25 = {
                    name: notification.EntityName,
                }, t("notification.consumable_storage_to_user", arg_25)),
                Icon: Icon_12,
                OnClick: (_arg_12) => {
                    RouterModule_nav(ofArray(["consumables", notification.EntityId]), 1, 1);
                },
            };
        }
        case "consumableReturnConsumableToStorage": {
            const Icon_13 = some(Followers());
            return {
                DisplayName: (arg_27 = {
                    name: notification.EntityName,
                    sender: notification.Sender,
                }, t("notification.consumable_back_to_storage", arg_27)),
                Icon: Icon_13,
                OnClick: (_arg_13) => {
                    RouterModule_nav(ofArray(["consumables", notification.EntityId]), 1, 1);
                },
            };
        }
        case "consumableReturnConsumableToStorageRequest": {
            const Icon_14 = some(Shipment_Return());
            return {
                DisplayName: (arg_29 = {
                    name: notification.EntityName,
                    sender: notification.Sender,
                }, t("notification.consumable_user_to_storage_request", arg_29)),
                Icon: Icon_14,
                OnClick: (_arg_14) => {
                    RouterModule_nav(ofArray(["consumables", notification.EntityId]), 1, 1);
                },
            };
        }
        case "storageToUserBulk": {
            const Icon_15 = some(Following());
            return {
                DisplayName: (arg_31 = {
                    name: notification.EntityName,
                    sender: notification.Sender,
                }, t("notification.storage_to_user_bulk", arg_31)),
                Icon: Icon_15,
                OnClick: (_arg_15) => {
                    RouterModule_nav(ofArray(["assignment-notifications", NotificationId__get_unwrap(notification.Id)]), 1, 1);
                },
            };
        }
        default: {
            const Icon = some(Followers());
            return {
                DisplayName: (arg_1 = {
                    name: notification.EntityName,
                    sender: notification.Sender,
                }, t("notification.tool_back_to_storage", arg_1)),
                Icon: Icon,
                OnClick: (_arg) => {
                    RouterModule_nav(ofArray(["tools", notification.EntityId]), 1, 1);
                },
            };
        }
    }
}

export const notificationsKey = "/api/notifications";

export function refreshNotifications() {
    mutate(notificationsKey);
}

export function Notifications(props) {
    let elems_1;
    const patternInput = useTranslation();
    const swrResponse = swr(notificationsKey, (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(OverviewNotification_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), {
        refreshInterval: 60000,
    });
    let elements;
    const matchValue_1 = swrResponse.data;
    let matchResult;
    if (swrResponse.error != null) {
        matchResult = 1;
    }
    else if (matchValue_1 == null) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0: {
            elements = append(props.AdditionalElements, map((notification) => toDropdownButtonElement((arg, arg_1) => (patternInput[1].t(arg, arg_1)), notification), matchValue_1));
            break;
        }
        default:
            elements = props.AdditionalElements;
    }
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mr-5"])], (elems_1 = toList(delay(() => {
        let elems;
        return swrResponse.isLoading ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["animate-[spin_1.5s_linear_infinite]", "text-primary"])], (elems = [Loading_Circle()], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : (isEmpty(elements) ? singleton_1(createElement(DropdownButton, {
            Classes: singleton("z-[11]"),
            ComponentState: "disabled",
            DisplayArrow: false,
            DisplayDivider: true,
            Elements: empty(),
            Icon: Bell_Notification(),
            TestId: "notification-bell",
        })) : singleton_1(createElement(DropdownButton, {
            Classes: singleton("z-[11]"),
            ComponentState: "enabled",
            DisplayArrow: false,
            DisplayDivider: true,
            Elements: elements,
            Icon: Notification_Alarm_2(),
            TestId: "notification-bell",
        })));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

